module.exports = __webpack_public_path__ + "assets/46e36d83e8fffcd2c379f2af73ee2669.woff";